const stores = (state = {}, data) => {
    switch (data.type) {
        case 'SET_SELECTED_STORE':
            return {
                ...state,
                selectedStore: data.storeId.toString(),
            };
        case 'SET_STORES':
            return {
                ...state,
                list: data.stores,
            };
        default:
            return state;
    }
};

export default stores;
